import React from 'react'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'

const Wrapper = styled.div`
    flex: 0 1 auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    justify-items: center;
`

const TextWrapper = styled.div`
    align-items: center; // maybe flex-end
    &.btn {
        border: 1px solid ${(props) => props.color || 'white'};
    }
    &.premonth {
        span {
            font-size: 16px;
            @media (min-width: 1280px) {
                font-size: 16px;
            }
        }
    }
    span {
        color: ${(props) => props.color || 'white'};
        font-size: 16px;
        @media (min-width: 1280px) {
            font-size: 20px;
        }
    }
    pointer-events: none;
    margin-bottom: 0.67em;
`

const TextHeader = styled.h3`
    font-size: 24px;
    margin-bottom: 0.33em;

    &.premonth {
        font-size: 24px;
    }

    @media (min-width: 1280px) {
        font-size: 26px;

        &.premonth {
            font-size: 24px;
        }
    }
`

const TextInformationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    &.hidden: {
        display: none;
    }
    &.hide: {
        visibility: hidden;
    }
`

const TextInformation = ({ color, text, value, hide, perMonthText, isFirst }) => (
    <>
        <TextInformationWrapper className={hide ? (isFirst ? 'hide' : 'hidden') : ''}>
            <TextHeader className={perMonthText && 'premonth'}>{text}</TextHeader>

            <TextWrapper color={color} className={perMonthText ? 'btn premonth' : 'btn'}>
                <NumberFormat value={value} prefix="$" thousandSeparator displayType="text" />
                {perMonthText && <span>/ Month</span>}
            </TextWrapper>
        </TextInformationWrapper>
    </>
)

const DisplayRowInformation = ({ items, className, perMonthText = false }) => (
    <Wrapper className={className}>
        {items && !items.every((_) => _.hide === true) ? (
            items.map((item, i) => {
                const { text, color, value, hide } = item
                return (
                    <TextInformation
                        key={`${text}-${color}-${value}`}
                        color={color}
                        text={text}
                        value={value}
                        hide={hide}
                        perMonthText={perMonthText}
                    />
                )
            })
        ) : (
            <TextInformation
                key="placeholder"
                color="placeholder"
                text="placeholder"
                value={1000}
                hide={true}
                isFirst={true}
            />
        )}
    </Wrapper>
)

export default DisplayRowInformation
